import { useCallback, useEffect, useState } from "react";
import MenuCM from "components/shared/menu";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import NotFound from "components/shared/NotFound/NotFound";
import { useForm } from "react-hook-form";
import LoadingCM from "components/shared/Loading";
import PaymentIcon from "@mui/icons-material/Payment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PlaceIcon from "@mui/icons-material/Place";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import Button from "@mui/material/Button";
import useHttp from "hooks/use-http";
import { Link, useNavigate, useParams } from "react-router-dom";
import Toast from "helper/toast";
import spliter from "helper/digit-spliter";
import { AddDiscount } from "validations";
import { yupResolver } from "@hookform/resolvers/yup";
import ContactCM from "components/contactus";
import {
  getCartRequest,
  getUserInfoRequest,
  getUserAddressRequest,
  addOrderRequest,
  addDiscountCodeRequest,
} from "api/requests";
import {
  StyledPaper,
  StyledTitle,
  StyledPrice,
  StyledRadioBtn,
  StyledButton,
  StyledDiscount,
  StyledPaperDiscount,
  StyledButton2,
} from "./Payment.style";
import { Container, TextField } from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import FooterCM from "components/shared/footer";
import { blue } from "@mui/material/colors";
import { Helmet } from "react-helmet";

export default function Payment() {
  const params = useParams();
  const navigate = useNavigate();
  const { request, loading } = useHttp();
  const [user, setUser] = useState(0);
  const [address, setAddress] = useState({ data: [], count: 0 });
  const [orders, setOrders] = useState({ count: 0, data: [] });
  const [checked, setChecked] = useState(false);
  const [discountCode, setDiscountCode] = useState(false);
  const [totalPrice, setTotalPrice] = useState({
    totalPrice: "",
    fixedPrice: "",
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AddDiscount),
  });

  const handleToggle = async (event) => {
    setChecked(event.target.value);
  };

  // console.log(checked);

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });
    if (res) {
      setUser(res);
    }
  }, [request]);

  const getAddress = useCallback(async () => {
    const res = await request({
      url: getUserAddressRequest,
      values: {
        skip: 0,
        limit: 100,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      address: items?.address,
    }));

    setAddress({ data: transformedData, count: res.count });
  }, [request]);

  const getOrders = async () => {
    const res = await request({
      url: getCartRequest,
      values: {
        skip: 0,
        limit: 100,
        userId: params.userId,
      },
    });

    setOrders({
      count: res.count,
      total_price: res.total_price,
    });
    setTotalPrice({
      totalPrice: res.total_price,
      fixedPrice: res.total_price,
    });
    if (res.total_price == 0) {
      navigate("/");
    }
  };

  const onSubmit = async (values) => {
    if (checked == false) {
      return Toast({
        type: "empty",
        title: "آدرس خود را",
      });
    } else {
      let res = await request({
        url: addOrderRequest,
        values: {
          user_address_id: checked,
          discount_code: values.discount_code,
          description: values.description,
        },
      });
      if (res) {
        reset({
          discount_code: "",
        });
        Toast({ type: "success", title: "ثبت سفارش" });
        window.location.replace(res?.data?.payment_url);
      }
    }
  };

  const onSubmitDiscountCode = async (values) => {
    let res = await request({
      url: addDiscountCodeRequest,
      values: {
        discount_code: values.discount_code,
      },
    });

    if (res) {
      reset({
        discount_code: "",
      });
      // This State For Show Total Price Befor DiscoutCode And Next
      setDiscountCode(true);
      Toast({ type: "custom-success", title: "کد تخفیف با موفقیت اعمال شد" });
      if (res.discount_code.type === "percentage") {
        setOrders({
          total_price: (totalPrice.totalPrice -=
            (totalPrice.totalPrice / 100) * res.discount_code.amount),
        });
      } else {
        setOrders({
          total_price: totalPrice.totalPrice - res.discount_code.amount,
        });
      }
    } else {
      // Toast({ type: "custom-err", title: "کد تخفیف اشتباه است" });
    }
  };

  useEffect(() => {
    getUserInfo();
    getOrders();
    getAddress();
    setChecked(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>پرداخت - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Box
          style={{
            marginBottom: orders.count == 0 ? "50px" : "160px",
            marginTop: "70px",
          }}
        >
          <>
            <MenuCM Background pageTitle="پرداخت" />
            <Container>
              {orders?.count == 0 ? (
                <NotFound title="فاکتور شما خالی است" />
              ) : (
                <Grid container direction="row">
                  <Grid item xs={12}>
                    <StyledPaper>
                      <div>
                        <StyledTitle>
                          <PlaceIcon /> <span>انتخاب آدرس</span>
                        </StyledTitle>
                        {user.type == "user" ? (
                          <div style={{ textAlign: "left" }}>
                            <Link to={`/address/add`}>
                              <Button
                                variant="outlined"
                                style={{ marginLeft: "10px" }}
                              >
                                <AddLocationIcon />{" "}
                                <span style={{ marginRight: "10px" }}>
                                  ثبت آدرس جدید
                                </span>
                              </Button>
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div>
                        {address.data.map((items, index) => (
                          <div key={"card" + index}>
                            <StyledRadioBtn
                              checked={checked == items.id ? true : false}
                              onChange={handleToggle}
                              value={items.id}
                              style={{
                                // boxShadow: "0px 0px 1px 0px black",
                                // background: "transparent",
                                borderRadius: "50%",
                                // border:
                                //   checked == items.id
                                //     ? "4px solid #149ec4"
                                //     : "4px solid transparent",
                              }}
                              id={"card" + index}
                              sx={{
                                color: blue[800],
                                "&.Mui-checked": {
                                  color: blue[600],
                                },
                              }}
                            />
                            <label htmlFor={"card" + index}>
                              {items.address}
                            </label>
                          </div>
                        ))}
                      </div>
                    </StyledPaper>
                  </Grid>
                  <Grid item xs={12}>
                    <StyledPaper>
                      <div>
                        <StyledTitle>
                          <PaymentIcon /> <span>روش پرداخت</span>
                        </StyledTitle>
                        <StyledPrice>پرداخت آنلاین</StyledPrice>
                      </div>
                    </StyledPaper>
                  </Grid>
                  <Grid item xs={12}>
                    <StyledPaperDiscount>
                      <div>
                        <StyledTitle>
                          <LocalOfferIcon /> <span>کد تخفیف</span>
                        </StyledTitle>
                        <StyledDiscount>
                          <TextField
                            size="small"
                            label="کد تخفیف"
                            variant="outlined"
                            style={{ width: "300px" }}
                            id="discount_code"
                            {...register("discount_code")}
                            error={Boolean(errors.discount_code)}
                            helpertext={errors.discount_code?.message}
                          />
                          <StyledButton2
                            variant="contained"
                            onClick={handleSubmit(onSubmitDiscountCode)}
                            style={{ width: "150px", marginRight: 10 }}
                          >
                            <LocalOfferIcon style={{ marginLeft: "6px" }} />
                            اعمال کد{" "}
                          </StyledButton2>
                        </StyledDiscount>
                      </div>
                    </StyledPaperDiscount>
                  </Grid>
                  <Grid item xs={12}>
                    <StyledPaper>
                      <div>
                        <StyledTitle>
                          <PaymentIcon /> <span>توضیحات</span>{" "}
                          <span style={{ fontSize: "18px" }}>
                            {
                              "(اگر در رابطه با نحوه ارسال کالا توضیح خاصی دارید میتوانید در کادر زیر وارد نمایید.)"
                            }
                          </span>
                        </StyledTitle>
                      </div>
                      <div style={{ width: "100%" }}>
                        <TextField
                          size="small"
                          label="توضیحات"
                          variant="outlined"
                          fullWidth
                          multiline
                          rows={3}
                          id="description"
                          {...register("description")}
                          error={Boolean(errors.description)}
                          helpertext={errors.description?.message}
                        />
                      </div>
                    </StyledPaper>
                  </Grid>
                  <Grid item xs={12}>
                    <StyledPaper>
                      <div>
                        <StyledTitle>
                          <AttachMoneyIcon /> <span>قیمت کل</span>
                        </StyledTitle>
                        {!discountCode ? (
                          <StyledPrice>
                            {spliter(orders.total_price)} تومان
                          </StyledPrice>
                        ) : (
                          <>
                            <StyledPrice>
                              <span>قیمت قبل تخفیف:‌</span>{" "}
                              {spliter(totalPrice.fixedPrice)} تومان
                            </StyledPrice>

                            <StyledPrice>
                              <span>قیمت بعد تخفیف:</span>{" "}
                              {spliter(orders.total_price)} تومان
                            </StyledPrice>
                          </>
                        )}
                      </div>
                    </StyledPaper>
                  </Grid>
                  <Grid item xs={12} style={{ direction: "ltr" }}>
                    <StyledButton
                      variant="contained"
                      onClick={handleSubmit(onSubmit)}
                    >
                      پرداخت سفارش <PaymentIcon style={{ marginLeft: "6px" }} />
                    </StyledButton>
                  </Grid>
                </Grid>
              )}
            </Container>
            <ContactCM All />
            <FooterCM />
          </>
        </Box>
      )}
    </>
  );
}
